import { AutoMap } from "@automapper/classes";
import { ELimitValueType } from "./enum/limit-value-type";

export class Limit {
    public constructor(init?: Partial<Limit>) {
        Object.assign(this, init);
    }

    @AutoMap()
    Code: string = ''
    @AutoMap()
    Name: string = ''
    @AutoMap()
    Value1: number = 1
    @AutoMap()
    Type1: ELimitValueType = ELimitValueType.Inferieur
    @AutoMap()
    Value2: number = 1
    @AutoMap()
    Type2: ELimitValueType = ELimitValueType.Inferieur
    @AutoMap()
    Multiplier: number = 1;

}